import { gql } from 'graphql-tag';

export const editUserPasswordQueries = gql`
    mutation EditUserPassword(
        $id:String!,
		$password:String!
    ){
        editUserPassword(
            id:$id,
		    password:$password
        )
    }

    mutation DeleteUsers(
        $userIds: [String!]!,
        $hardDelete: Boolean
    ){
        deleteUsers(
            userIds: $userIds,
            hardDelete: $hardDelete
        )
    }
`;

export const SEND_RESET_PASSWORD_MUTATION = gql`
    mutation SendResetPassword($userId: String!) {
        sendResetPassword(userId: $userId)
    }
`;

export const DEACTIVATE_USER_REFRESH_TOKENS_MUTATION = gql`
    mutation DeactivateUserRefreshTokens($userId: String!) {
        deactivateUserRefreshTokens(userId: $userId)
    }
`;

export const QUICK_INVITE_MUTATION = gql`
    mutation QuickInvite(
        $email: String,
        $phone: String,
        $givenName: String,
        $familyName: String,
        $roles: [String!],
        $sendInvite: Boolean
    ) {
        quickInvite(
            email: $email,
            phone: $phone,
            givenName: $givenName,
            familyName: $familyName,
            roles: $roles,
            sendInvite: $sendInvite
        ) {
            total
            users {
                id
                email
            }
            failedUsers {
                error
            }
        }
    }
`;

